export const TOKEN_PROP_NAME: string = 'auth-token';

export const LOCAL_EVENT_FILTER_US_STATE = 'local_event_filter_us_state';

export const LOCAL_EVENT_FILTER_LANGUAGE = 'local_event_filter_language';

export const LOCAL_EVENT_FILTER_ZIP_CODE = 'local_event_filter_zip_code';

export const LOCAL_EVENT_FILTER_HEALTH_PLAN = 'local_event_filter_health_plan';
